<template>
  <div class="intro_bg" :class="fadeoutClass" >
   <div class="home_notice" :class="fadeoutClass" >
     <p>by830.choi 님, 안녕하세요.</p>
     <p>오늘 진행중인 작업 <span class="bl">0건</span>, 지연된 작업 <span class="or">21건</span> 있습니다.</p>
   </div>  
</div>

  
</template>

<script>
export default {
  name: 'PGE_CMP_00017', 
  data() {
    return {
       triggered: false,
    };
  },
  computed: {
      fadeoutClass() {
          if (this.triggered) {
            return 'fade-out';
          }          
      }
    },
  watch: {},
  datasets: [],
  mounted() {
      setTimeout(() => { this.triggered = true }, 2000);
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style scoped>
.fade-out {
    -webkit-animation-name: fadeOut;
    animation-name: fadeOut;
    animation:fadeOut ease 1s;
    -webkit-animation: fadeOut ease 1s;
    -moz-animation: fadeOut ease 1s;
    -o-animation: fadeOut ease 1s;
    -ms-animation: fadeOut ease 1s;
}

@keyframes fadeOut{
  0% {
    opacity:1;
  }
  100% {
    opacity:0;
  }
}

@-moz-keyframes fadeOut {
  0% {
    opacity:1;
  }
  100% {
    opacity:0;
  }
}

@-webkit-keyframes fadeOut {
  0% {
    opacity:1;
  }
  100% {
    opacity:0;
  }
}

@-o-keyframes fadeOut {
  0% {
    opacity:1;
  }
  100% {
    opacity:0;
  }
}

@-ms-keyframes fadeOut {
  0% {
    opacity:1;
  }
  100% {
    opacity:0;
  }
}

.intro_bg {
  height: 100%;
  background-image:url('../../../../assets/images/portal_intro_bg.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.home_notice{
    position:absolute;
    font-size:22px;
    color:#333;
    font-weight:normal;
	bottom: 70px;
    left: 160px;
  }
.home_notice>p span.bl{color:#336aff;font-weight:bold}
.home_notice>p span.or{color:#ee9022;font-weight:bold}
</style>
